import { gql } from '@apollo/client'

export const BRAND_DISRUPTOR_SUMMARY_STATS = gql`
  query SummaryStatsQuery($input: DateRangeInput!) {
    summaryStats(input: $input) {
      trendingUp {
        brand {
          id
          name
        }
        delta
      }
      trendingDown {
        brand {
          id
          name
        }
        delta
      }
      newBrands {
        brand {
          id
          name
        }
        dateFirstObserved
        numberOfStores
        numberOfFacings
      }
    }
  }
`
